import httpClient from "@utils/httpClient";

// Get all public holidays (optionally for a specific financial year)
export const getPublicHolidays = async (fyYear = null) => {
  try {
    const url = fyYear ? `/holidays/public?year=${fyYear}` : '/holidays/public';
    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getPublicHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get all optional holidays (optionally for a specific financial year)
export const getOptionalHolidays = async (fyYear = null) => {
  try {
    const url = fyYear ? `/holidays/optional?year=${fyYear}` : '/holidays/optional';
    const response = await httpClient.get(url);

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getOptionalHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get employee's selected optional holidays
export const getSelectedOptionalHolidays = async () => {
  try {
    const response = await httpClient.get('/holidays/selected');

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getSelectedOptionalHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Submit selected optional holidays
export const submitSelectedHolidays = async (holidayIds) => {
  try {
    const response = await httpClient.post('/holidays/select', {
      holiday_ids: holidayIds
    });

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('submitSelectedHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get holiday configuration limits
export const getHolidayConfig = async (fyYear = null) => {
  try {
    const url = fyYear ? `/holidays/config?fy_year=${fyYear}` : '/holidays/config';
    console.log(`[HolidayService] Calling holiday config API: ${url}`);
    const response = await httpClient.get(url);
    console.log(`[HolidayService] Holiday config API response:`, response);
    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('getHolidayConfig error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Cancel one or more optional holidays
export const cancelOptionalHolidays = async (holidayIds) => {
  try {
    const response = await httpClient.post('/holidays/cancel', {
      holiday_ids: holidayIds
    });

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('cancelOptionalHolidays error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get all available financial years with holiday data
export const getAvailableYears = async () => {
  try {
    const response = await httpClient.get('/holidays/available-years');

    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    console.error('getAvailableYears error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Check if holiday data exists for a specific financial year
export const checkDataForYear = async (fyYear) => {
  try {
    const response = await httpClient.get(`/holidays/check-year/${fyYear}`);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('checkDataForYear error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};
